export class AIFieldDefinition{
    Name: string;
    Type: string;
}